import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { useDispatch } from "react-redux";
import { redirect, useNavigate } from "react-router-dom";
import { authService } from "services/authServices";
import { login } from "store/apps/auth";

export default function useLoginByGoogle() {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const _onGoogleLogin = async () => {
    try {
      const provider = new GoogleAuthProvider();

      const auth = getAuth();

      const result = await signInWithPopup(auth, provider);

      const user = await authService.signInWithGoogle(result.user.uid, result.user.email || "");

      dispatch(login(user));

      navigate("/");
    } catch (error) {
      throw error;
    }
  };

  return { _onGoogleLogin };
}
